import { Building2, Users } from "lucide-react";

export const TEAM_SIZES = ["1-5", "6-10", "11-25", "26-50", "51-100", "más de 100"];

export const DiagnosticContextFields = ({ companyName, teamSize, onChange }) => (
  <div className="mt-8 rounded-2xl border border-gray-100 bg-white p-5 md:p-6" data-testid="diagnostic-context-fields">
    <div className="text-[11px] font-semibold tracking-[0.18em] uppercase text-[#0f6e56] mb-1">Datos de tu empresa · opcional</div>
    <p className="text-[13px] text-slate-500 mb-4 leading-relaxed">
      Solo se usan para personalizar la portada y el resumen del Team Readiness Report. No afectan a tu puntuación.
    </p>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <label className="block">
        <span className="flex items-center gap-1.5 text-[13px] font-medium text-slate-700 mb-1.5">
          <Building2 className="w-4 h-4 text-[#0f6e56]" /> Nombre de la empresa
        </span>
        <input
          type="text"
          maxLength={120}
          value={companyName}
          onChange={(e) => onChange({ companyName: e.target.value })}
          placeholder="Ej.: Acme Tech"
          className="w-full rounded-xl border border-gray-200 px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#0f6e56]/30"
          data-testid="diagnostic-company-name-input"
        />
      </label>
      <label className="block">
        <span className="flex items-center gap-1.5 text-[13px] font-medium text-slate-700 mb-1.5">
          <Users className="w-4 h-4 text-[#0f6e56]" /> Tamaño del equipo
        </span>
        <select
          value={teamSize}
          onChange={(e) => onChange({ teamSize: e.target.value })}
          className="w-full rounded-xl border border-gray-200 px-3 py-2.5 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#0f6e56]/30"
          data-testid="diagnostic-team-size-select"
        >
          <option value="">Prefiero no indicarlo</option>
          {TEAM_SIZES.map((s) => (
            <option key={s} value={s}>{s} personas</option>
          ))}
        </select>
      </label>
    </div>
  </div>
);
